export default function (state) {
  if (!state.currentVersionId || !state.versions[state.currentVersionId]) {
    return null;
  }

  return state.versions[state.currentVersionId];
}
